import React, { useState } from "react";
import PropTypes from "kf-proptypes/widgets";

import { isEmpty } from "base/utils";

import { SearchWidget } from "./search.widget.jsx";
import { DropDownWrapper, NoResultsFound } from "./index.jsx";
import { UserMenuItem } from "@widgets/datadisplay/usermenuitem/index.jsx";
import { Checkbox } from "../../checkbox/index.jsx";

import styles from "./multiuserselect.css";

export function MultiUserSelectWidget(props) {
  let {
    value,
    onSearch,
    searchAutoFocus = false,
    dataSource = null,
    onChange = () => {}
  } = props;
  let [searchText, setSearchText] = useState("");
  let [initialValues] = useState(value);

  function isActive(item) {
    if (!value) {
      return false;
    }
    let isFound = value?.find(
      (user) => JSON.stringify(user) === JSON.stringify(item)
    );
    return isFound;
  }
  function handleChange(item) {
    if (!value) {
      return [];
    }
    let isFound = value?.find(
      (user) => JSON.stringify(user) === JSON.stringify(item)
    );
    let filteredValues = [];
    if (isFound) {
      filteredValues = value?.filter(
        (user) => JSON.stringify(user) !== JSON.stringify(item)
      );
    } else {
      filteredValues = [...value, item];
    }
    onChange(filteredValues);
  }
  function checkisItemAlreadyFound({ item }) {
    let isFound = initialValues?.find(
      (user) => JSON.stringify(user) === JSON.stringify(item)
    );
    return isFound;
  }
  return (
    <div className={styles.wrapper}>
      {onSearch && (
        <SearchWidget
          onSearch={(value) => {
            setSearchText(value);
            onSearch(value);
          }}
          searchAutoFocus={searchAutoFocus}
        />
      )}
      <DropDownWrapper>
        <div>
          {isEmpty(searchText) && !isEmpty(initialValues) && (
            <div className={styles.initialValuesWrapper}>
              {initialValues.map((item, index) => {
                if (!item) {
                  return null;
                }
                return (
                  <MultiUserSelectItem
                    active={isActive(item)}
                    user={item}
                    value={value}
                    key={index}
                    onClick={() => {
                      handleChange(item);
                    }}
                  />
                );
              })}
            </div>
          )}
          {dataSource.map((item, index) => {
            if (checkisItemAlreadyFound({ item })) {
              return null;
            }
            return (
              <MultiUserSelectItem
                active={isActive(item)}
                user={item}
                value={value}
                key={index}
                onClick={() => {
                  handleChange(item);
                }}
              />
            );
          })}
          {isEmpty(dataSource) && <NoResultsFound searchText={searchText} />}
        </div>
      </DropDownWrapper>
    </div>
  );
}

MultiUserSelectWidget.propTypes = {
  value: PropTypes.arrayOf(
    PropTypes.shape({
      Kind: PropTypes.string.isRequired,
      Name: PropTypes.string.isRequired,
      _id: PropTypes.string.isRequired,
      Email: PropTypes.string.isRequired
    })
  ),
  onSearch: PropTypes.func,
  dataSource: PropTypes.arrayOf(
    PropTypes.shape({
      Kind: PropTypes.string.isRequired,
      Name: PropTypes.string.isRequired,
      _id: PropTypes.string.isRequired,
      Email: PropTypes.string.isRequired
    })
  ),
  onChange: PropTypes.func,
  searchAutoFocus: PropTypes.func
};

export function MultiUserSelectItem(props) {
  let { onClick, active = false, user } = props;
  let { disabled = false } = user;

  return (
    <div
      onClick={() => {
        if (onClick) {
          if (!disabled) {
            onClick();
          }
        }
      }}
      className={`${disabled && styles.disabled} ${styles.dropDownItem}`}
    >
      <Checkbox value={active} />
      <UserMenuItem
        userId={user._id}
        name={user.Name}
        email={user.Email}
        kind={user.Kind}
      />
    </div>
  );
}

MultiUserSelectItem.propTypes = {
  onClick: PropTypes.func,
  active: PropTypes.bool,
  user: PropTypes.shape({
    disabled: PropTypes.bool,
    Kind: PropTypes.string.isRequired,
    Name: PropTypes.string.isRequired,
    _id: PropTypes.string.isRequired,
    Email: PropTypes.string.isRequired
  })
};
